// extracted by mini-css-extract-plugin
export default {"chat":"kkzMdp","messages":"zLdmQa","controls":"dAICxI","backToBottom":"HnNdJr"};